import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=a74f9cda"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports